var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model-list-select',{staticClass:"custom-select",style:({ width: _vm.width }),attrs:{"list":_vm.optionsList,"title":_vm.$t('typeToSearch'),"option-value":"username","custom-text":item => {
      return item.firstName + ' ' + item.lastName
    },"filter-predicate":(text, inputText) => {
      return true
    },"is-error":_vm.search.length > 0 && _vm.search.length < 3,"placeholder":_vm.$t('typeToSearch')},on:{"searchchange":_vm.onSearchChange},model:{value:(_vm.selectedUsername),callback:function ($$v) {_vm.selectedUsername=$$v},expression:"selectedUsername"}})
}
var staticRenderFns = []

export { render, staticRenderFns }